let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6oEbr")).then(() => parcelRequire('dztrC'));